import { z } from '../utils/zodConfig';

/**
 * Zod schema for electricity costs
 */
const electricityCostsSchema = z.object({
  tariffType: z.enum(['simple', 'hc_hp'], {
    message: 'Choisissez un type de tarif valide',
  }),
  simpleTariff: z
    .number()
    .min(0, 'Le tarif doit être positif')
    .optional(),
  hcTariff: z
    .number()
    .min(0, 'Le tarif heures creuses doit être positif')
    .optional(),
  hpTariff: z
    .number()
    .min(0, 'Le tarif heures pleines doit être positif')
    .optional(),
}).refine(
  (data) => {
    // If tariffType is 'simple', simpleTariff must be provided
    if (data.tariffType === 'simple' && !data.simpleTariff) {
      return false;
    }
    // If tariffType is 'hc_hp', both hcTariff and hpTariff must be provided
    if (data.tariffType === 'hc_hp' && (!data.hcTariff || !data.hpTariff)) {
      return false;
    }
    return true;
  },
  {
    message: 'Les tarifs requis pour le type de facturation sélectionné doivent être renseignés',
    path: ['tariffType'],
  }
);

/**
 * Zod schema for solar panels configuration
 */
const solarPanelsSchema = z.object({
  enabled: z.boolean(),
  averageDailyProduction: z
    .number()
    .min(0, 'La production doit être positive')
    .optional(),
});

/**
 * Zod schema for global settings
 * Validates all application settings including declaration frequency,
 * electricity costs, solar panels, and BNC tax rate
 */
export const settingsSchema = z.object({
  declarationFrequency: z.enum(['mensuel', 'trimestriel', 'annuel'], {
    message: 'Choisissez mensuel, trimestriel ou annuel',
  }),

  electricityCosts: electricityCostsSchema,

  solarPanels: solarPanelsSchema,

  bncRate: z
    .number()
    .min(0, 'Le taux BNC doit être positif')
    .max(1, 'Le taux BNC ne peut pas dépasser 100%'),
});

export type SettingsFormData = z.infer<typeof settingsSchema>;
